/*
 * @Author: czj
 * @Date: 2026-06-27 16:35:03
 * @Description:  系统相关接口
 * @FilePath: \kp-rag-system\src\api\system.js
 */

import request from '@/utils/request';

// 获取Websocket配置
export function getWebsocketConfig(params) {
  return request({
    url: `/api/getWebsocketConfig`,
    method: 'get',
    params
  })
}

/** 获取系统配置 */
export function system_conf() {
  return request({
    url: '/api/system_conf',
    method: 'get',
  })
}

/** 保存系统配置 */
export function set_system_conf(data) {
  return request({
    url: '/api/system_conf/1',
    method: 'put',
    data,
  })
}

/** 恢复系统配置默认值 */
export function obj_recovery(ticket) {
  return request({
    url: '/api/obj_recovery',
    method: 'post',
    data: { ticket },
  })
}

/** 获取字典配置 */
export function getTableDictionariesInfo(params) {
  return request({
    url: '/api/getTableDictionariesInfo',
    method: 'get',
    params,
  })
}